module.exports = __webpack_public_path__ + "static/media/museosanscyrl.b58926be.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansCyrl500/museosanscyrl.woff2
// module id = 644
// module chunks = 0